import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { ISettingsGroups } from '../interfaces';
import { saveAppSettings } from '../api';
import { useSnackbar } from 'notistack';

export function useSaveAppSettings() {
  const [disabled, setDisabled] = useState(false);

  const { addError } = useError();
  const { enqueueSnackbar } = useSnackbar();

  async function handleSaveAppSettings(settings: ISettingsGroups) {
    setDisabled(true);

    try {
      await saveAppSettings(
        settings
          .map(({ settings }) => settings)
          .flat()
          .map(({ key, value }) => ({ key, value })),
      );
      enqueueSnackbar('Настройки успешно сохранены', { variant: 'success' });
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setDisabled(false);
    }
  }

  return { disabled, handleSaveAppSettings };
}
